import { render, staticRenderFns } from "./ds-manager-registration-list.vue?vue&type=template&id=3c2dc8ce&scoped=true"
import script from "./ds-manager-registration-list.vue?vue&type=script&lang=js"
export * from "./ds-manager-registration-list.vue?vue&type=script&lang=js"
import style0 from "./ds-manager-registration-list.vue?vue&type=style&index=0&id=3c2dc8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2dc8ce",
  null
  
)

/* custom blocks */
import block0 from "./ds-manager-registration-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports